import { render, staticRenderFns } from "./DxBinsInfoForm.vue?vue&type=template&id=33a8a2c8&scoped=true&"
import script from "./DxBinsInfoForm.vue?vue&type=script&lang=js&"
export * from "./DxBinsInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./DxBinsInfoForm.vue?vue&type=style&index=0&id=33a8a2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8a2c8",
  null
  
)

export default component.exports